@if (ticket$ | async; as ticket) {
  <div
    class="detailed-list-container"
    [ngClass]="{ 'no-travels': ticket.travels.length <= 0 }"
  >
    @if (ticket.travels.length <= 0) {
      <p>{{ 'noTripsRecorded' | i18nextCap }}</p>
    }
    @for (travel of ticket.travels; track travel; let i = $index) {
      <div class="detailed-list-item">
        <div class="detailed-list-item-details">
          <mat-icon>mode_of_travel</mat-icon>
          <div class="info">
            <span class="title mat-body-1 color-grey-600">{{
              travel.startingHour | date: 'dd/MM/yyyy'
            }}</span>
            <div class="subtitle">
              <crm-assignees-icon-list
                [assignees]="parseAssignees(travel)"
                [size]="18"
                [maxDisplay]="4"
              ></crm-assignees-icon-list>
              <span class="color-grey-400">
                <mat-icon class="color-grey-500">straighten</mat-icon>
                {{ travel.distance }} km
              </span>
              <span class="color-grey-400">
                <mat-icon class="color-grey-500">schedule</mat-icon>
                {{
                  formatTimeDiffToString(travel.startingHour, travel.endingHour)
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button
            mat-icon-button
            type="button"
            class="color-grey-600"
            (click)="openForm(travel)"
          >
            <mat-icon>open_in_new</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
}
<div class="add-period-container">
  <button mat-stroked-button type="button" color="primary" (click)="openForm()">
    <mat-icon>assignment_add</mat-icon>
    {{ 'add' | i18nextCap }}
  </button>
</div>

@if (travelHistory$ | async; as totals) {
  <div class="totals">
    @for (at of totals.assigneesTravels; track at.id) {
      <div class="totals-row">
        <span class="xlight">{{ at.firstName }} {{ at.lastName }}</span>
        <span class="semi-bold color-grey-700">{{
          formatDuration(at.total)
        }}</span>
      </div>
    }
    <div class="totals-row totals-overall">
      <span>{{ 'total' | i18nextCap }}</span>
      <span>{{ totals.totalDistance }} km</span>
      <span>{{ formatDuration(totals.totalHours) }}</span>
    </div>
  </div>
}
